<template>
    <div ref="record">
        <div class="container">
            <div class="handle-box">
                <el-row :gutter="10" style="margin-bottom:10px">
                    <el-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">类&emsp;&emsp;别</span>
                        <el-select size="mini" v-model="searchParam.categoryParentIds" multiple clearable placeholder="类别">
                            <el-option v-for="item in categoryList" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
                        </el-select>
                    </el-col>
                    <el-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">姓&emsp;&emsp;名</span>
                        <el-input size="mini" v-model="searchParam.chName" label="姓名" placeholder="姓名" clearable @clear="searchParam.chName = null" class="handle-input"></el-input>
                    </el-col>
                    <el-col  :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">学员邮箱</span>
                        <el-input size="mini" v-model="searchParam.email" placeholder="学员邮箱" clearable @clear="searchParam.email = null" class="handle-input"></el-input>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="8">
                        <span class="label">创建时间</span>
                        <el-date-picker
                            size="mini"
                            style="width:200px"
                            v-model="searchParam.startTime"
                            type="datetime"
                            placeholder="开始时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="'00:00:00'">
                        </el-date-picker>
                        <span class="label" style="margin:0 5px;">至</span>
                        <el-date-picker
                            size="mini"
                            style="handle-input"
                            v-model="searchParam.endTime"
                            type="datetime"
                            placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="'00:00:00'">
                        </el-date-picker>
                    </el-col>
                </el-row>
                <el-row type="flex"  justify="end">
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
                    <el-button size="mini" type="primary" icon="el-icon-tickets" @click="manageCategory">CPE类别及项目</el-button>
                </el-row>
            </div>
            <el-table :data="tableData" border stripe style="width: 100%" ref="multipleTable" :max-height="tableLen">
                <el-table-column prop="id" label="ID"  width="100" fixed="left"></el-table-column>
                <el-table-column prop="createTime" label="申请时间" width="200" fixed="left"></el-table-column>
                <el-table-column prop="chName" label="姓名"  width="120" fixed="left"></el-table-column>
                <el-table-column prop="email" label="邮箱" width="200"></el-table-column>
                <el-table-column prop="categoryParentName" label="类别"  width="200" ></el-table-column>
                <el-table-column prop="categoryName" label="具体项目" width="200"></el-table-column>
                <el-table-column prop="num" label="CPE" width="50" ></el-table-column>
                <el-table-column label="活动时间" width="180">
                    <template slot-scope="scope">
                        {{scope.row.startTime.substring(0,10)}}至{{scope.row.endTime.substring(0,10)}}
                    </template>
                </el-table-column>
                <el-table-column prop="activityProvider" label="活动提供者" width="200"></el-table-column>
                <el-table-column prop="activityDes" label="活动描述" width="300"></el-table-column>
                <el-table-column prop="reason" label="原因" width="300"></el-table-column>
                <el-table-column prop="state" label="状态" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state===1" type="primary" disable-transitions>审核中</el-tag>
                        <el-tag v-if="scope.row.state===2" type="success" disable-transitions>审核通过</el-tag>
                        <el-tag v-if="scope.row.state===3" type="danger" disable-transitions>审核不通过</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="240" fixed="right">
                    <template slot-scope="scope">
                        <el-button  size="small" type="primary" @click="attachFile(scope.row)">附件</el-button>
                        <el-button v-if="scope.row.state !== 2" size="small" type="primary" @click="accept( scope.row.id)">通过</el-button>
                        <el-button v-if="scope.row.state !== 3" size="small" type="danger" @click="refuse(scope.row.id)">不通过</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @current-change="getData" :current-page.sync="searchParam.pageNum" :page-size.sync="searchParam.pageSize" layout="total,sizes,prev, pager, next" :total="totalNumber">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="附件" :visible.sync="attachFileVisible" width="80%">
            <el-table :data="attachfileList" stripe style="width: 100%" ref="attachfileListTable" :max-height="tableLen">
                <el-table-column prop="attachFileOriginalName" label="文件名称" fixed="left"></el-table-column>
                <el-table-column prop="attachFileObjectName" label="文件ID" fixed="left" ></el-table-column>
                <el-table-column label="图片预览" align="center" width="300">
                    <template slot-scope="scope">
                        <img v-if="scope.row.image" :src="scope.row.url"  width="100%" height="auto">
                    </template>
                </el-table-column>
                <el-table-column label="操作"  width="200" fixed="right" >
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" @click="download(scope.row.url)">下载</el-button>
                        <el-button v-if="scope.row.docx || scope.row.pdf" size="small" type="primary" @click="previewAttachFile(scope.row)">预览</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog title="CPE类别及项目" :visible.sync="manageCategoryVisible" width="80%" >
            <div class="handle-box">
                <el-row type="flex"  justify="end">
                    <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addCategory" >添加类别</el-button>
                </el-row>
            </div>
            <el-table :data="categoryList" border stripe style="width: 100%" ref="multipleTable" :max-height="tableLen">
                <el-table-column prop="id" label="ID"  width="100"></el-table-column>
                <el-table-column prop="disable" label="类别" width="300">
                    <template slot-scope="scope">
                        <el-tag v-if="!scope.row.disable" type="primary" disable-transitions>正常</el-tag>
                        <el-tag v-if="scope.row.disable" type="info" disable-transitions>禁用</el-tag>
                        {{scope.row.categoryName}}
                    </template>
                </el-table-column>
                <el-table-column label="具体项目">
                    <template slot-scope="scope2">
                        <ul class="moreColumn">
                            <li v-for="(item,i) in scope2.row['categoryList']" :key="i" >
                                <el-tag v-if="!item.disable" type="primary" disable-transitions>正常</el-tag>
                                <el-tag v-if="item.disable" type="info" disable-transitions>禁用</el-tag>
                                {{item.categoryName}}
                            </li>
                        </ul>
                    </template>
                </el-table-column>
                <el-table-column label="可获得的CPE数量" align="center" width="120">
                    <template slot-scope="scope3">
                        <ul class="moreColumn">
                            <li v-for="(item,i) in scope3.row['categoryList']" :key="i" >{{item.num}}</li>
                        </ul>
                    </template>
                </el-table-column>
                <el-table-column label="项目操作" width="120">
                    <template slot-scope="scope4">
                        <ul class="moreColumn">
                            <li v-for="(item,i) in scope4.row['categoryList']" :key="i" >
                                <el-button type="text" @click="editSubCategory(i, item)">编辑</el-button>
                                <el-button v-if="!item.disable" type="text" style="color: red" @click="disableCategory(i,item)">禁用</el-button>
                                <el-button v-if="item.disable" type="text" @click="enableCategory(i,item)">启用</el-button>
                            </li>
                        </ul>
                    </template>
                </el-table-column>
                <el-table-column label="类别操作" width="300">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" @click="editCategory(scope.$index, scope.row)">编辑</el-button>
                        <el-button v-if="!scope.row.disable" size="small" type="danger" @click="disableCategory(scope.$index, scope.row)">禁用</el-button>
                        <el-button v-if="scope.row.disable" size="small" type="primary" @click="enableCategory(scope.$index, scope.row)">启用</el-button>
                        <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addSubCategory(scope.$index, scope.row)" >添加项目</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="添加具体项目" :visible.sync="addSubCategoryVisible" width="30%">
            <el-form :model="addSubCategoryForm" label-width="100px">
                <el-form-item label="具体项目" >
                    <el-input v-model="addSubCategoryForm.categoryName"></el-input>
                </el-form-item>
                <el-form-item label="CPE数量" >
                    <el-input-number v-model="addSubCategoryForm.num" :min="1"  label="可获得的CPE数量"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addSubCategoryVisible = false">取 消</el-button>
                <el-button type="primary" @click="postAddSubCategory">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="编辑具体项目" :visible.sync="editSubCategoryVisible" width="30%">
            <el-form :model="editSubCategoryForm" label-width="100px">
                <el-form-item label="具体项目" >
                    <el-input v-model="editSubCategoryForm.categoryName"></el-input>
                </el-form-item>
                <el-form-item label="CPE数量" >
                    <el-input-number v-model="editSubCategoryForm.num" :min="1"  label="可获得的CPE数量"></el-input-number>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editSubCategoryVisible = false">取 消</el-button>
                <el-button type="primary" @click="postEditSubCategory">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name:'record',
        data() {
            return {
                tableLen:350,
                searchParam:{
                    pageNum:1,
                    pageSize:10,
                },
                tableData:[],
                totalNumber:0,
                attachFileVisible:false,
                attachfileList:[],
                categoryList:[],
                manageCategoryVisible: false,
                addSubCategoryVisible: false,
                addSubCategoryForm:{},
                editSubCategoryVisible:false,
                editSubCategoryForm:{},
            };
        },

        created(){
            this.getCategoryList();
            this.getData();
        },
        updated() {
            this.tableLen=window.innerHeight-135;
        },
        methods: {
            async getData(){
                let res = await this.$axios.post('/manage/cpe/selectByPage',this.searchParam);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }

                this.tableData = res.data.list;
                this.totalNumber = res.data.total;
            },
            async accept(id) {
                let res = await this.$axios.get(`/manage/cpe/accept?id=${id}`)
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                await this.getData();
            },
            async refuse(id) {
                let reason = await this.$prompt("请输入不通过原因","不通过原因",{inputPattern:/^[\w\W]+$/, inputErrorMessage:'原因输入不正确'}).catch(err=>{return Promise.resolve(null)});
                if (!reason) {
                    return;
                }
                let res = await this.$axios.get(`/manage/cpe/refuse?id=${id}&reason=${reason.value}`)
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                await this.getData();
            },
            async attachFile(row) {
                let res = await this.$axios.get(`/manage/cpe/attachFile?id=${row.id}`)
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                this.attachfileList = res.data
                for(let af of this.attachfileList) {
                    if(af.attachFileOriginalName.endsWith("jpeg") ||af.attachFileOriginalName.endsWith("jpg")|| af.attachFileOriginalName.endsWith("png") ) {
                        af.image = true;
                    } else {
                        af.image = false;
                    }
                    af.docx = af.attachFileOriginalName.endsWith("docx");
                    af.pdf = af.attachFileOriginalName.endsWith("pdf");
                }
                console.log(this.attachfileList)
                this.attachFileVisible=true;
            },
            download(url) {
                window.open(url);
            },
            async manageCategory() {
                await this.getCategoryList();
                this.manageCategoryVisible=true;
            },
            async getCategoryList() {
                let res = await  this.$axios.get("/manage/cpe/categoryList") ;
                if (res.code !=200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                this.categoryList = res.data
            },
            async addCategory() {
                let category = await this.$prompt("请输入类别名称","添加类别",{inputPattern:/^[\w\W]+$/, inputErrorMessage:'类别输入不正确'}).catch(err=>{return Promise.resolve(null)});
                if (!category) {
                    return;
                }

                let res = await this.$axios.post(`/manage/cpe/addCategory`,{
                    level: 1,
                    parentId:0,
                    categoryName: category.value,
                    num:0,
                });
                if (res.code !=200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                await this.getCategoryList();
            },
            async editCategory(index,row) {
                let category = await this.$prompt(
                    "请输入类别名称",
                    "添加类别",
                    {
                        inputPattern:/^[\w\W]+$/,
                        inputValue: row.categoryName,
                        inputErrorMessage:'类别输入不正确'}
                ).catch(err=>{return Promise.resolve(null)});
                if (!category) {
                    return;
                }

                let res = await this.$axios.post(`/manage/cpe/updateCategory`,{
                    id: row.id,
                    categoryName: category.value,
                });
                if (res.code !=200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                await this.getCategoryList();
            },
            addSubCategory(index,row){
                this.addSubCategoryForm = {
                    level:2,
                    parentId:row.id,
                    categoryName:null,
                    num:5,
                }
                this.addSubCategoryVisible=true;
            },
            async postAddSubCategory(){
                let res = await this.$axios.post(`/manage/cpe/addCategory`,this.addSubCategoryForm);
                if (res.code !=200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                await this.getCategoryList();
                this.addSubCategoryVisible=false;
            },
            editSubCategory(index, row) {
                this.editSubCategoryForm = {
                    id: row.id,
                    level: row.level,
                    parentId:row.parentId,
                    categoryName:row.categoryName,
                    num:row.num
                }
                this.editSubCategoryVisible=true;
            },
            async postEditSubCategory(){
                let res = await this.$axios.post(`/manage/cpe/updateCategory`,this.editSubCategoryForm);
                if (res.code !=200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                await this.getCategoryList();
                this.editSubCategoryVisible=false;
            },
            async disableCategory(index, row) {
                let res = await this.$axios.get(`/manage/cpe/disableCategory?id=${row.id}`);
                if (res.code !=200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                await this.getCategoryList();
            },
            async enableCategory(index, row) {
                let res = await this.$axios.get(`/manage/cpe/enableCategory?id=${row.id}`);
                if (res.code !=200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                await this.getCategoryList();
            },
            async previewAttachFile(af) {
                if (af.docx) {
                    let url = encodeURIComponent(af.url);
                    window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
                } else if (af.pdf) {
                    let res = await this.$axios.get(af.url,{responseType:'blob'});
                    let href = window.URL.createObjectURL(new Blob([res.data],{type:'application/pdf;charset=utf-8'}));
                    window.open(href,af.attachFileObjectName)
                } else {
                    this.$message.error("不支持预览该文件")
                }
            },
        }
    };
</script>

<style scoped>
.handle-box {
    margin-bottom: 10px;
}
.el-col{
    margin: 10px 0;
}
/* .handle-select {
    width: 200px;
}

.handle-input {
    width: 200px;
} */
.label {
    margin-right: 10px;
    color: #606266;
}
.moreColumn li{
    list-style: none;
    line-height:34px;
    margin: 0 -10px;
    padding: 0 10px;
}
.moreColumn li+li{
    border-top: 1px solid #ebeef5;
}
.moreColumn li:first-child {
    margin-top: -4px;
}
.moreColumn li:last-child{
    margin-bottom: -4px;
}
</style>
